import _ from "lodash";
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export default function OrderCharts({ data }) {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (data && data.totalFilter) {
      getChartData(data.totalFilter);
    }
  }, [data]);

  const getChartData = (orders) => {
    setOptions({
      /**
       * Apex defaults are a grey-on-grey grid with a full border box — fine for a demo,
       * dated on a product. What reads as modern here is restraint: no vertical grid, a
       * faint horizontal rule only, no axis borders, and one brand colour doing the work.
       */
      chart: {
        fontFamily: "FontLao2",
        id: "dashboard-orders",
        toolbar: { show: false },
        //* The chart draws its own shadow; the panel around it already has one.
        dropShadow: { enabled: false },
        animations: { enabled: true, easing: "easeinout", speed: 420 },
        parentHeightOffset: 0,
      },
      //* Brand red, with the purple end of the gradient as the fade target.
      colors: ["#DB1237"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: .18,
          gradientToColors: ["#8E1759"],
          opacityFrom: .95,
          opacityTo: .80,
          stops: [0, 100],
        },
      },
      plotOptions: {
        bar: {
          //* Rounded caps are the single clearest signal that a chart was designed
          //* rather than defaulted.
          borderRadius: 6,
          borderRadiusApplication: "end",
          columnWidth: "52%",
        },
      },
      dataLabels: { enabled: false },
      grid: {
        borderColor: "#F1EEF6",
        strokeDashArray: 0,
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } },
        padding: { top: 0, right: 8, bottom: 0, left: 4 },
      },
      xaxis: {
        categories: orders.map((day) => day.name),
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: {
          style: { colors: "#8B8397", fontSize: "12px", fontWeight: 500 },
        },
        crosshairs: { show: false },
      },
      yaxis: {
        //* Floor at zero and give an all-zero series a sane ceiling, so a quiet day draws
        //* an empty chart with a 0..4 axis rather than a broken one.
        min: 0,
        forceNiceScale: true,
        tickAmount: 4,
        labels: {
          style: { colors: "#8B8397", fontSize: "12px" },
          /**
           * Whole orders only — Apex otherwise invents 0.4 of an order on an empty day.
           *
           * The guard is not defensive padding: with every value zero Apex cannot derive a
           * range and hands the formatter ±Infinity, which Math.round passes straight
           * through. That is what printed the literal word "Infinity" up the y-axis of an
           * empty chart.
           */
          formatter: (v) => (Number.isFinite(v) ? Math.round(v) : ""),
        },
      },
      tooltip: {
        theme: "light",
        style: { fontSize: "13px", fontFamily: "FontLao2" },
        marker: { show: false },
        y: { formatter: (v) => `${Math.round(v)}` },
      },
      states: {
        hover: { filter: { type: "darken", value: .9 } },
        active: { filter: { type: "none" } },
      },
      legend: { show: false },
    });
    setSeries([
      {
        name: "ຈຳນວນມື້ນີ້", // will be displayed on the y-axis
        data: orders.map((day) => {
          return parseInt(day.amount, 10);
        }),
      },
    ]);
  };

  // if(_.isEmpty(data)) return <div style={{width:'100%', height:315}}>
  //   <img src="https://static.vecteezy.com/ti/vecteur-libre/p1/5006029-le-processus-termine-le-paquet-de-commande-est-arrive-avec-une-notification-pour-smartphone-concept-illustration-flat-design-vector-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographie-vectoriel.jpg" />
  // </div>

  return (
    <div>
      <Chart
        options={options}
        type="bar"
        series={series}
        width="100%"
        height="315px"
      />
    </div>
  );
}